export const createCanvasPattern = (fillColor: string | undefined) => {
  if (!fillColor) return null;
  const patternCanvas = document.createElement("canvas");
  const patternContext = patternCanvas.getContext("2d");
  if (!patternContext) return null;
  patternCanvas.width = 10;
  patternCanvas.height = 10;

  patternContext.fillStyle = fillColor;
  patternContext.fillRect(0, 0, patternCanvas.width, patternCanvas.height);
  patternContext.moveTo(0, 0);
  patternContext.lineTo(10, 10);
  patternContext.stroke();

  const cnv = document.createElement("canvas");
  const ctx = cnv.getContext("2d");

  const pattern = ctx?.createPattern(patternCanvas, "repeat");

  return pattern;
};
